export default __webpack_public_path__ + "static/media/daniel.7cface3e.jpg";